import React, { useEffect } from "react"
import { Image, View } from "react-native"
import { useDispatch, useSelector } from "react-redux"
import Colors from "../../../constants/Colorsv2"
import { Text, TouchableOpacity } from "../../../globalComponents/NativeOverrides"
import { player_getBulkPlayers } from "../../../store/actionsv1/player"
import { PublicPlayerProps } from "../../../store/types/auth_svc"
import { comp_formatPlace } from "../../Comps/helpers/competition"

type LeaderCardProps = {
    player_id:string,
    title_override?:string,
    score_description:string,
    winnings_label:string,
    place:number,
    onLeaderSelect: (player_id:string) => void
}
const LeaderCard = ({ player_id, place, title_override, score_description, winnings_label, onLeaderSelect }:LeaderCardProps) => {

    const dispatch = useDispatch();
    const leader:PublicPlayerProps = useSelector((state:any) => state.social.stored_players.find(p => p.player_id == player_id), (left, right) => left?.player_id == right?.player_id)

    useEffect(() => {
        getDataFromServer(player_id)
    },[player_id])

    const getDataFromServer = (player_id:string) => {
        if(!leader){ dispatch(player_getBulkPlayers([player_id])) }
    }
    if(!leader){ return <></> }
    return (
        <TouchableOpacity style={{ flex:1, flexDirection:'row', alignItems:'center', borderRadius:100, backgroundColor:Colors.shades.white, padding:5, paddingRight:15, paddingLeft:15 }} onPress={() => onLeaderSelect(player_id)}>
            <View style={{ flex:1/6 }}>
                <Text size={12} color={Colors.brand.midnight} weight='semibold'>{comp_formatPlace(place)}</Text>
            </View>
            <View style={{flex:1/6}}>
                <Image source={leader.profile_pic??require('../../../assets/images/default-avatar.png')} style={{ height:30, width:30, borderRadius:100 }} resizeMode='cover' />
            </View>
            <View style={{ flex:3/6 }}>
                <Text size={12} color={Colors.brand.midnight} weight='regular'>{title_override??leader.username}</Text>
                <Text size={12} color={Colors.brand.slate} weight='regular'>{score_description}</Text>
            </View>
            <View style={{ flex:1/6 }}>
                <Text size={12} color={Colors.brand.slate} weight='regular'>{winnings_label}</Text>
            </View>
        </TouchableOpacity>
    )
}

export default LeaderCard